import React from 'react';
import classNames from 'classnames';
import { node, any, number, string } from 'prop-types';
import FormatDateTime from '../../platformui/FormatDateTime';
import DateCard from './date-card';
import EventDetails from './event-details';

const EventArticleList = (props) => {
  const teaserTheme = classNames({
    'c-event-article-list__theme--default': !props.Theme,
    [`c-event-article-list__theme--${props.Theme}`]: props.Theme,
  });

  const headerClasses = classNames({
    'c-event-article-list__heading': true,
    [teaserTheme]: props.Theme,
  });

  const infoType = `c-event-article-list__type--${props.InformationType}`;
  const teaserClasses = classNames({
    'c-event-article-list': true,
    'c-event-article-list--related': true,
    'c-event-article-list--no-text': !props.Preamble,
    'c-event-article-list--full-layout': props.numOfItems === 1,
    'c-event-article-list--nth2': props.numOfItems === 2,
    'c-event-article-list--nth1': props.numOfItems === 1,
    'c-event-article-list--gt1': props.numOfItems > 1,
    'c-event-article-list--gt2': props.numOfItems > 2,
    'c-event-article-list--gt3': props.numOfItems > 3,
    [`c-event-article-list--${props.Theme}`]: props.Theme,
    [teaserTheme]: props.Theme,
    [infoType]: props.InformationType,
  });

  return (
    props.Title && (
      <div
        className={teaserClasses}
        onClick={() => (window.location.href = props.Url)}
      >
        <div className="c-event-article-list__content-wrapper">
          <div className="c-event-article-list__date-container">
            <DateCard date={props.EventStart} />
          </div>
          <div className="c-event-article-list__text-container">
            {props.Vignette && (
              <span className="c-event-article-list__vignette">
                {props.Vignette}
              </span>
            )}
            {props.Date && <FormatDateTime date={props.Date} />}
            <h3
              data-event-category={props.Url}
              data-event-action={props.Title}
              data-event-name="Evenemang i lista"
              className={headerClasses}
            >
              <a
                data-event-include
                className="c-event-article-list__link"
                href={props.Url}
              >
                {props.Title}
              </a>
            </h3>
            {typeof props.Preamble === 'string' && (
              <div className="c-event-article-list__text">
                <p>{props.Preamble}</p>
              </div>
            )}
            {props.EventStart && (
              <EventDetails
                startDate={props.EventStart}
                endDate={props.EventEnd}
                location={props.EventLocation}
              />
            )}
          </div>
        </div>
      </div>
    )
  );
};

EventArticleList.propTypes = {
  Preamble: node,
  numOfItems: number,
  Vignette: node,
  Theme: string,
  Title: string,
  Url: string,
  Media: any,
};

export default EventArticleList;
